<af-main-container [title]="'i18n_lib_breadcrumb#TrendId' | translate :{trendId: trend?.id || trendId}"
                   [customLastBreadcrumb]="'i18n_lib_breadcrumb#TrendId' | translate :{trendId: trend?.id || trendId}"
                   [buttonLabel]="showButton && (buttonLabel | translate)"
                   (buttonClickListener)="makeConclusionOrRateTrend()"
                   [tabPathToTab]="tabPathToTab"
                   [navigateBackListener]="navigateBack"
                   spinnerIds="initial">
    @if (trend?.isDeleted) {
        <div fxLayout="column" fxLayoutAlign="start start" fxLayoutGap="4px"
             class="bc-secondary-red-100 radius-16 pt-16 pr-24 pb-16 pl-24 w-100 mt-24">
            <div class="t2-semi-bold">{{ 'i18n_af_labelTrendDeletedReason' | translate : {reason: deletedBaseName} }}</div>
            <div class="t4">{{ trend.deletionReason }}</div>
        </div>
    }
    <div CustomTitle class="w-100 mr-16 ml-16" fxLayout="row" fxLayoutAlign="space-between center" fxFlex>
        @if (trend) {
            <af-status [statusText]="statusName" [status]="statusStyle"/>
        }

        <div fxLayout="row" fxLayoutAlign="end center">
            @if (reportDownloadIsAvailable) {
                <ui-kit-svg class="i-24 pointer ml-16 c-primary-green-800" name="ic_download_document"
                            [matTooltip]="'i18n_af_buttonDownloadReport' | translate"
                            (click)="downloadReport()"/>
            }

            @if (!trend?.isReadOnly && authHolderService.hasAccess(['npck-admin'])) {
                <ui-kit-svg class="i-24 pointer ml-16 c-primary-green-800" name="ic_edit"
                            [matTooltip]="'i18n_af_labelEdit' | translate"
                            (click)="editTrend()"/>
            }

            @if (!trend?.isDeleted && authHolderService.hasAccess(['npck-admin'])) {
                <ui-kit-svg class="i-24 pointer ml-16 c-primary-green-800" name="ic_delete"
                            [matTooltip]="'i18n_af_labelDelete' | translate"
                            (click)="deleteTrend()"/>
            }
        </div>
    </div>
    <div class="w-100 h-100" fxLayout="column" fxLayoutAlign="start start" fxFlex>
        <af-info class="w-100 mt-24" [info]="info"/>
        @if (trend) {
            <mat-tab-group
                mat-align-tabs="start"
                animationDuration="0"
                fxFlex
                class="mt-16 w-100 h-100 overflow-y-scroll"
                [(selectedIndex)]="selectedTabIndex"
                (selectedIndexChange)="handleNavigation($event)">
                @for (tab of tabs; track tab) {
                    <mat-tab [label]="'i18n_af_' + tab | translate" class="text-center h-100">
                        <ng-template matTabContent>
                            @if (activeTab === tab) {
                                @if (tab === 'tabTrendDetails') {
                                    <af-trend-details-tab [trend]="trend" class="mt-24 w-100 h-fit-content" fxFlex/>
                                }
                                @if (tab === 'tabTrendIncidents') {
                                    <af-trend-incidents-tab [trend]="trend"/>
                                }
                                @if (tab === 'tabTrendStatistics') {
                                    <af-trend-statistic-tab [trend]="trend"/>
                                }
                                @if (tab === 'tabTrendFeedbacks') {
                                    <af-trend-feedback-tab [trend]="trend"/>
                                }
                                @if (tab === 'tabHistory') {
                                    <af-entity-history [entityId]="trendId" [entityType]="EntityType.TREND" mode="full"/>
                                }
                            }
                        </ng-template>
                    </mat-tab>
                }
            </mat-tab-group>
        }
    </div>
</af-main-container>
